import { Box, Skeleton } from "@mui/material";

const CandidateDetailsLoading = () => {
  return (
    <Box sx={styles.container}>
      {/* Header Loading */}
      <Box sx={styles.header}>
        <Skeleton variant="circular" width={32} height={32} />
        <Skeleton variant="text" width={150} height={30} />
      </Box>

      {/* User Info Loading */}
      <Box sx={styles.userInfoContainer}>
        <Box sx={styles.userInfo}>
          <Skeleton variant="circular" width={64} height={64} />
          <Box sx={styles.userInfoDetails}>
            <Skeleton variant="text" width={200} height={32} />
            <Skeleton variant="text" width={150} height={24} />
          </Box>
        </Box>
        <Box sx={styles.buttons}>
          <Skeleton variant="rectangular" width={100} height={36} sx={{ borderRadius: "8px" }} />
          <Skeleton variant="rectangular" width={100} height={36} sx={{ borderRadius: "8px" }} />
        </Box>
      </Box>

      {/* Navigation Loading */}
      <Box sx={styles.navigation}>
        <Skeleton variant="rectangular" width={100} height={40} sx={{ borderRadius: "8px" }} />
        <Skeleton variant="rectangular" width={120} height={40} sx={{ borderRadius: "8px" }} />
      </Box>

      {/* Content Loading (Overview Tab) */}
      <Box sx={styles.content}>
        {/* Stage Container */}
        <Box sx={styles.sectionContainer}>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
            <Skeleton variant="text" width={140} height={28} />
            <Skeleton variant="rectangular" width={120} height={40} sx={{ borderRadius: "8px" }} />
          </Box>
        </Box>

        {/* Fit Score Container */}
        <Box sx={styles.sectionContainer}>
          <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: "24px", width: "100%" }}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "16px", flex: 1 }}>
              <Skeleton variant="text" width={120} height={24} />
              <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
                <Skeleton variant="circular" width={200} height={200} />
              </Box>
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "16px", flex: 1 }}>
              <Skeleton variant="text" width={150} height={24} />
              <Skeleton variant="rectangular" width="100%" height={100} sx={{ borderRadius: "8px" }} />
            </Box>
          </Box>
        </Box>

        {/* Persona Overview Loading */}
        <Box sx={styles.sectionContainer}>
          <Skeleton variant="text" width={160} height={24} />
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: "16px", mt: 2 }}>
            <Skeleton variant="rectangular" width={180} height={80} sx={{ borderRadius: "8px" }} />
            <Skeleton variant="rectangular" width={180} height={80} sx={{ borderRadius: "8px" }} />
            <Skeleton variant="rectangular" width={180} height={80} sx={{ borderRadius: "8px" }} />
          </Box>
        </Box>

        {/* Overview Container */}
        <Box sx={styles.sectionContainer}>
          <Skeleton variant="text" width={180} height={24} />
          <Box sx={{ display: "flex", gap: "16px", mt: 2 }}>
            <Skeleton variant="rectangular" width={200} height={80} sx={{ borderRadius: "8px" }} />
            <Skeleton variant="rectangular" width={200} height={80} sx={{ borderRadius: "8px" }} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default CandidateDetailsLoading;

const styles = {
  container: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  userInfoContainer: {
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: "24px",
  },
  userInfo: {
    display: "flex",
    alignItems: "center",
    gap: "20px",
  },
  userInfoDetails: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  buttons: {
    display: "flex",
    gap: "12px",
    width: { xs: "100%", sm: "fit-content" },
  },
  navigation: {
    display: "flex",
    gap: "12px",
    borderBottom: "1px solid #EAECF0",
    pb: "12px",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  sectionContainer: {
    padding: "20px",
    borderRadius: "8px",
    border: "1px solid #EAECF0",
    background: "#FFF",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
};
